import { useNavigate } from 'react-router'
import { Hub } from 'aws-amplify'

const useCheckForRedirectUrlAfterLogin = () => {
  const navigate = useNavigate()
  Hub.listen('auth', ({ payload: { event, data } }) => {
    if (event === 'customOAuthState') {
      const storedPathForRedirectAfterLogin = JSON.parse(data)
      navigate(storedPathForRedirectAfterLogin)
    }
  })
}

export default useCheckForRedirectUrlAfterLogin
